document.addEventListener('DOMContentLoaded', function() {
  var loadSvgDetails = [
    {
      'selector': ['#shopify-section-template--24009034531143__173298802648394f84 #shopify-block-kehio_editor_app_block_faq_xiFMrp'],
      'svg_url':'https://cdn.shopify.com/s/files/1/0863/7635/0023/files/F_Gradient_White.svg?v=1733046094',
      'css': {
        'position': 'absolute',
        'left': '0',
        'top': '0',
        'width': '40%',
        'z-index': '-1',
        'opacity': '0.5',
        'class': 'svg_bg_3',
        'display': 'block',
        'mediaQueries': {
          '(max-width: 767px)': {
    		'display': 'none'
          },
          '(min-width: 768px) and (max-width: 1024px)': {
    		'width': '40%'
          },
          '(min-width: 1025px) and (max-width: 1280px)': {
    		'width': '40%'
          },
          '(min-width: 1281px) and (max-width: 1439px)': {
    		'width': '40%'
          },
          '(min-width: 1440px)': {
    		'width': '40%'
          }
        }
      }
    },
    {
      'selector': ['#shopify-section-template--21471196152107__1686159157bc3d096d','#shopify-section-template--22578758320427__16900405694738ec8e','#shopify-section-template--22578784600363__16900357188b2b8cdb'],
      'svg_url':'https://cdn.shopify.com/s/files/1/0741/2829/4187/files/K_Gradient_Orange.svg?v=1699536451',
      'css': {
        'position': 'absolute',
        'right': '0',
        'top': '0',
        'z-index': '0',
        'width': '100%',
        'opacity': '0.5',
        'class': 'svg_bg_4',
        'display': 'none',
        'mediaQueries': {
          '(max-width: 768px)': {
                'display': 'block',
            },
            '(min-width: 768px)': {
                'display': 'none',
            }
          }
      }
    },
  ];

  var resizeTimeout;//

  var resizeTimeout;

  for (var i = 0; i < loadSvgDetails.length; i++) {
    
    var selectors = loadSvgDetails[i].selector;
    var svgType = loadSvgDetails[i].svg;
    var cssProperties = loadSvgDetails[i].css;
    var mediaQueries = cssProperties.mediaQueries;
    var container = document.createElement('div');
    if(typeof loadSvgDetails[i].svg_url !== "undefined" && loadSvgDetails[i].svg_url != ''){
      var innerHtmlToAdd = '<img alt src="'+loadSvgDetails[i].svg_url+'" >';
    }else{
      var innerHtmlToAdd = svgData[svgType]
    }
    for (var s = 0; s < selectors.length; s++) {
      var selector = selectors[s];
      var element = document.querySelector(selector);
      if (element) {
        
        container.innerHTML = innerHtmlToAdd;
        var svgElement = container.firstChild;
  
        element.appendChild(container);
        element.classList.add('dfredfd_container');
        container.classList.add(cssProperties.class);
        container.classList.add(cssProperties.class+'_'+s);
        container.classList.add('svg_bg_wrap');
        container.classList.add('fade_up_animate');
        //container.setAttribute('data-aos','fade-up');
        //container.setAttribute('data-aos-once','false');
       // if (window.scrollY === 0) {
         // container.setAttribute('data-aos-offset', '100');
       //   }
  
        applyCSSProperties(container, cssProperties);
  
        for (var mqQuery in mediaQueries) {
          var mqCSSProperties = mediaQueries[mqQuery];
  
          var mediaQueryList = window.matchMedia(mqQuery);
          mediaQueryList.addListener(createMediaQueryListener(container, mqCSSProperties));
  
          if (mediaQueryList.matches) {
            applyCSSProperties(container, mqCSSProperties);
          }
        }
        handleScroll();
        //Initialize AOS with desired options
        // AOS.init({
        //   duration: 1000,
        //   delay: 200,
        //   easing: 'ease-in-out',
        //  // data-aos-once
        //   // Add more options as needed
        // });
      } else {
        //console.log('Element with selector:', selector, ' not found.');
      }
    }
  }

  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      for (var i = 0; i < loadSvgDetails.length; i++) {
        var selectors = loadSvgDetails[i].selector;
        
        var mediaQueries = loadSvgDetails[i].css.mediaQueries;
        for (var s = 0; s < selectors.length; s++) {
          var selector = selectors[s];
          
          var element = document.querySelector(selector);
  
          if (element) {
          //var container = element.querySelector('> .' + loadSvgDetails[i].css.class);
         // var childElements = Array.from(element.children);
          var container = document.querySelector(selector +' > .'+loadSvgDetails[i].css.class);

          for (var mqQuery in mediaQueries) {
            var mqCSSProperties = mediaQueries[mqQuery];
            var mediaQueryList = window.matchMedia(mqQuery);

            if (mediaQueryList.matches) {
              applyCSSProperties(container, mqCSSProperties);
            }
          }
        }
        }
      }
    }, 200); // Adjust the timeout duration as needed
  });
    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        
        // Check if the top of the element has started entering the viewport from the bottom
        return rect.top >= 0 && rect.top < windowHeight;
    }
    
    function handleScroll() {
        const fadeUpElements = document.querySelectorAll('.fade_up_animate:not(.animated)');  // Select elements that are not yet visible
        //console.log(fadeUpElements.length)
        fadeUpElements.forEach(element => {
            if (isInViewport(element)) {
                element.classList.add('animated');
            }
        });
    }
    
    window.addEventListener('scroll', handleScroll);

  function createMediaQueryListener(element, properties) {
    return function(mql) {
      if (mql.matches) {
        applyCSSProperties(element, properties);
      }
    };
  }

  function applyCSSProperties(element, properties) {
    for (var property in properties) {
      if (property === 'class') {
        element.classList.add(properties[property]);
      } else {
        element.style[property] = properties[property];
      }
    }
  }
  var buttons = document.querySelectorAll('a[href="#discuteravecunexpert"]');

    // Iterate over the selected elements and bind the click event handler
    buttons.forEach(function(button) {
      button.addEventListener('click', function() {
        // Code to execute when the button is clicked
        event.preventDefault();
        toggleDemoRequestForm();
        // Additional code...
      });
    });
    var imageSVG = '<?xml version="1.0" encoding="UTF-8"?><svg id="Calque_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94.5 94.09"><defs><style>.cls-1{fill:#772647;}</style></defs><g id="TexteLegging_-_copie"><path class="cls-1" d="M55.67,10.96c-.18,1.01-1.08,1.62-2.08,1.44s-1.62-1.08-1.44-2.08,1.08-1.62,2.08-1.44,1.62,1.08,1.44,2.08Z"/><path class="cls-1" d="M63.44,15.54l-.35-8.96-.03-.02-3.33,7.27-2.92-1.34,5.06-11.01,3.98,1.83.3,7.75h.03s2.89-6.27,2.89-6.27l2.92,1.34-5.06,11.01-3.48-1.6Z"/><path class="cls-1" d="M78.15,14.45c-1.04,1.23-2.71,1.37-3.93.33-1.23-1.04-1.37-2.71-.33-3.93s2.71-1.37,3.93-.33,1.37,2.71.33,3.93ZM75.25,12c-.42.5-.4,1.09.06,1.48.47.4,1.08.34,1.5-.16.42-.5.39-1.11-.09-1.51-.46-.39-1.05-.31-1.47.19Z"/><path class="cls-1" d="M75.92,26.51l6.99-5-3.69-1.67,2.61-1.87,4.25,1.92,1.5,2.09-9.86,7.05-1.81-2.52Z"/><path class="cls-1" d="M81.79,34.23c-.94.39-1.95-.02-2.34-.96s.02-1.95.96-2.34c.94-.39,1.95.02,2.34.96s-.02,1.95-.96,2.34Z"/><path class="cls-1" d="M82.39,43.45l12.12.3-.08,3.32-9.16-.23-.14,5.62-2.96-.07.22-8.94Z"/><path class="cls-1" d="M86.56,63.04l-2.57-.83,1.41-4.34-1.65-.54-1.81,5.59-2.81-.91,2.84-8.75,11.53,3.74-2.84,8.75-2.81-.91,1.81-5.59-1.68-.55-1.41,4.34Z"/><path class="cls-1" d="M81.96,68.8c-1.64-1.19-3.48-.8-4.79,1-.17.24-.33.48-.47.74l1.25.91,1.26-1.72,2.18,1.59-3.14,4.3-5.22-3.81c.21-1.25.79-2.45,1.84-3.88,2.47-3.39,5.98-4.11,9.07-1.85,3.1,2.26,3.48,5.82,1.01,9.21-1.04,1.43-2.01,2.35-3.13,2.93l-2.9-2.12.09-.12c1.38-.25,2.56-1.07,3.48-2.32,1.31-1.8,1.12-3.68-.51-4.87Z"/><path class="cls-1" d="M72.77,78.95c-1.16-1.66-3.03-1.89-4.86-.62-.24.17-.47.35-.69.54l.89,1.27,1.75-1.22,1.54,2.22-4.38,3.04-3.69-5.3c.61-1.11,1.55-2.05,3-3.07,3.45-2.4,6.99-1.93,9.18,1.22s1.39,6.64-2.05,9.03c-1.45,1.01-2.67,1.57-3.92,1.75l-2.05-2.95.12-.08c1.39.21,2.77-.17,4.04-1.06,1.83-1.27,2.26-3.11,1.11-4.77Z"/><path class="cls-1" d="M65.59,90.11l-3.1,1.18-4.31-11.33,3.1-1.18,4.31,11.33Z"/><path class="cls-1" d="M49.42,81.62l4.9,7.51h.04s-.87-7.95-.87-7.95l3.19-.35,1.32,12.05-4.35.48-4.24-6.5h-.04s.75,6.88.75,6.88l-3.19.35-1.32-12.05,3.81-.42Z"/><path class="cls-1" d="M40.15,87.16c.47-1.97-.6-3.52-2.77-4.04-.28-.07-.57-.12-.86-.15l-.36,1.51,2.08.5-.63,2.63-5.18-1.24,1.5-6.28c1.23-.29,2.56-.21,4.29.2,4.08.98,6.1,3.93,5.2,7.66-.89,3.73-4.02,5.46-8.11,4.48-1.72-.41-2.94-.95-3.91-1.76l.84-3.5.14.03c.77,1.18,1.97,1.95,3.48,2.31,2.17.52,3.82-.38,4.29-2.35Z"/><path class="cls-1" d="M19.6,77.16c-.53-1.13-.42-2.25.35-3.23,1.37-1.75,3.61-1.65,6.04.26,1.34,1.05,2.31,2.32,2.56,3.36l-2.02,2.57-.12-.09c-.05-1.24-.9-2.67-2.1-3.62-.9-.71-1.68-.76-2.2-.1-.42.53-.16,1.03,1,1.95l1.21.95-1.58,2.01-1.06-.83c-1.16-.91-1.71-1.04-2.13-.51-.52.66-.31,1.38.55,2.05,1.03.81,2.47,1.22,3.67,1.03l.11.09-2.02,2.57c-1.13-.1-2.52-.75-3.74-1.71-2.24-1.76-2.78-3.82-1.4-5.58.72-.92,1.71-1.3,2.84-1.14l.02-.03Z"/><path class="cls-1" d="M8.01,72.68c-2.27-3.49-1.71-6.6,1.55-8.72,3.26-2.12,6.33-1.38,8.6,2.1l2.72,4.17-10.15,6.62-2.72-4.17ZM15.8,67.85c-1.22-1.87-2.66-2.21-4.4-1.07-1.74,1.14-2.01,2.6-.8,4.46l.8,1.22,5.2-3.39-.8-1.22Z"/><path class="cls-1" d="M13.37,56.22l-11.97,1.89-.52-3.28,9.05-1.43-.88-5.55,2.92-.46,1.4,8.83Z"/><path class="cls-1" d="M5.7,37.73l2.68.35-.59,4.52,1.72.22.76-5.83,2.93.38-1.18,9.12-12.02-1.56,1.18-9.12,2.93.38-.76,5.83,1.76.23.59-4.52Z"/><path class="cls-1" d="M13.32,22.71c3.27,1.62,4.42,5.14,2.75,8.51-1.67,3.37-5.17,4.59-8.44,2.97-3.27-1.62-4.42-5.14-2.75-8.51,1.67-3.37,5.17-4.59,8.44-2.97ZM9.13,31.18c1.75.87,3.49.36,4.3-1.27.81-1.64.16-3.32-1.59-4.19-1.75-.87-3.49-.36-4.3,1.27s-.16,3.32,1.59,4.19Z"/><path class="cls-1" d="M24.66,19.89l-8.42-3.07-.03.03,5.46,5.84-2.35,2.2-8.28-8.86,3.2-2.99,7.29,2.66.03-.02-4.73-5.05,2.35-2.2,8.28,8.86-2.8,2.62Z"/><path class="cls-1" d="M23.31,6.05l2.92-1.59,5.8,10.64-2.92,1.59-5.8-10.64Z"/><path class="cls-1" d="M39.11,4.9l.73,2.6-4.39,1.24.47,1.67,5.66-1.59.8,2.85-8.85,2.49-3.28-11.66,8.85-2.49.8,2.84-5.66,1.59.48,1.7,4.39-1.24Z"/></g></svg>';
    var imageSelector = [
      {'selector':'#shopify-section-template--24534930456953__174026178832ed8fae #faq_body_6405_info_7_1_1 > div','type':'left_svg'},
      {'selector':'#shopify-section-template--24534930456953__1740261838c2b7d838 #faq_body_6408_info_10_1_1 > div','type':'right_svg'}
    ];
    
    for (var s = 0; s < imageSelector.length; s++) {
      var selectorImg = imageSelector[s];
     // console.log('selector',selectorImg);
      var element = document.querySelector(selectorImg.selector);
      if (element) {
        var container = document.createElement('div');
        container.innerHTML = imageSVG;
        var svgElement = container.firstChild;
  
        element.appendChild(container);
        element.classList.add('image_svg_contain');
        container.classList.add('image_svg_wrap');
        container.classList.add(imageSelector[s].type);
      }
    }

    
    

});
